import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SettingsMenuComponent } from 'src/app/pages/settings-menu/settings-menu.component';
import { EntityTypeCode } from 'src/app/services/entities/entity-type.class';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss'],
    standalone: false,
})
export class PageHeaderComponent implements OnInit {
    @Input() title: string = environment.appTitle;
    @Input() subtitle: string;
    @Input() backLink: string = '/';
    @Input() backQueryParams: { [key: string]: any };
    @Input() print: boolean = false;

    @Input() date: Date;
    @Input() projectId: string;
    @Input() showPlanningFilter = false;
    @Input() showHelpIcon = false;

    @Output() headerClick = new EventEmitter<void>();
    @Output() selectedTeams = new EventEmitter<EntityTypeCode[]>();
    @Output() onOpenHelpClick = new EventEmitter<void>();

    @ViewChild(SettingsMenuComponent) settingsMenuComponent!: SettingsMenuComponent;

    constructor() {}

    ngOnInit(): void {}
}
